import { render, staticRenderFns } from "./SearchRequest.vue?vue&type=template&id=3bdce580"
import script from "./SearchRequest.vue?vue&type=script&lang=js"
export * from "./SearchRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports